import { graphql } from "~/gql";

export const USAGE_REPORT_QUERY = graphql(/* GraphQL */ `
  query UsageReport($input: UsageReportQueryInput!) {
    usageReportQuery(input: $input) {
      timeSeriesData {
        timeLabelString
        totalCount
        practiceAreaCounts {
          field
          id
          count
        }
        externalMattersStatusCounts {
          field
          id
          count
        }
      }
      aggregateData {
        totalCount
        mattersByUser {
          field
          id
          count
          metaData {
            key
            value
          }
        }
        mattersByStatus {
          field
          id
          count
        }
        externalMattersByStatus {
          field
          id
          count
        }
        mattersByLinkedUnlinked {
          field
          id
          count
        }
        mattersByPracticeArea {
          field
          id
          count
        }
        templatesByPracticeArea {
          field
          id
          count
        }
        practiceAreas {
          practiceArea {
            id
            name
          }
          byStatus {
            field
            id
            count
          }
          byLinkedUnlinked {
            field
            id
            count
          }
          templatesByTemplateType {
            field
            id
            count
          }
        }
      }
    }
  }
`);
